import React from 'react';
import FittedImage from 'react-fitted-img';
import { IArticle } from '../../definitions/news';
import { Link } from 'react-router-dom';
import { AppContext } from '../../Context';
import { IRootState } from '../../definitions/root';
import { truncate } from '../../services/utils';
import './Article.css';

interface IArticlePreviewProps {
  article: IArticle;
  articleKey?: string;
}

export const ArticlePreview = ({ article, articleKey }: IArticlePreviewProps) => {
  return (
    <AppContext.Consumer>
      {({ app: { isMobile, isTablet } }: IRootState) => {
        const truncateMaxChar = isMobile ? 76 : isTablet ? 60 : 60;

        return (
          <Link className="article-link" to={`news/${article.url}`} key={articleKey}>
            <article className="article">
              <div className="image-container">
                <FittedImage
                  className="fitted-img"
                  fit='cover'
                  decoding="async"
                  src={article.images.thumb}
                  srcSet={`${article.images.thumb} 240w`}
                  sizes="
                    (min-width: 320px) 420px,
                    (min-width: 768px) 380px,
                    (min-width: 1024px) 520px,
                    (min-width: 1200px) 640px
                  "
                  alt={article.title}/>

                  <div className="view">
                    <span className='view-text'>View</span>
                    <span className="line line-1" />
                    <span className="line line-2" />
                    <span className="line line-3" />
                    <span className="line line-4" />
                  </div>
              </div>

              <div className="article-details">
                <p className="title">{truncate(article.title, truncateMaxChar)}</p>
              </div>
            </article>
          </Link >
        );
      }}
    </AppContext.Consumer>
  );
};



// WEBPACK FOOTER //
// ./src/components/Article/Article.tsx